import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationBanner',
  props: {
  message: {
    type: [Array, String],
    required: true,
  },

  isDanger: {
    type: Boolean,
    default: false,
  },

  isWarning: {
    type: Boolean,
    default: false,
  },

  isSuccess: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const className = computed<string | null>(() => {
  if (props.isDanger) {
    return 'is-danger'
  }

  if (props.isWarning) {
    return 'is-warning'
  }

  if (props.isSuccess) {
    return 'is-success'
  }

  return null
})

const messageList = computed<Array<string>>(() =>
  Array.isArray(props.message) ? props.message : [props.message],
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([className.value, "notification-banner"])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("small", {
        key: `message-${index}`
      }, _toDisplayString(item), 1))
    }), 128))
  ], 2))
}
}

})